import { useMutation, useQueryClient } from '@tanstack/react-query';

import { createDemandDefinition } from '../../common/api/clients/demandDefinitions.api';
import type { SaveDemandDefinitionRequest } from '../../common/api/clients/demandDefinitions.api';
import { queries } from '../../common/api/queryKeys/queries';

export const useCreateDemandDefinition = (customerGroupId?: string) => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (request: SaveDemandDefinitionRequest) => createDemandDefinition(request, customerGroupId),
        onSuccess: (definition) => {
            queryClient.setQueryData(queries.demandDefinitions.detail(definition.id).queryKey, definition);

            return queryClient.invalidateQueries({ queryKey: queries.demandDefinitions.list._def });
        },
    });
};
